import arrayFilter from "./_arrayFilter.js";
import stubArray from "./stubArray.js";
var objectProto = Object.prototype, propertyIsEnumerable = objectProto.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols ? function(object) {
  return object == null ? [] : (object = Object(object), arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  }));
} : stubArray;
export {
  getSymbols as default
};
//# sourceMappingURL=_getSymbols.js.map
